import { all } from "redux-saga/effects";

export default function* personnelFormSaga() {
  yield all([]);
}
